import React, { Fragment, useState, useEffect, useContext } from 'react';
import { useForm } from 'react-hook-form';
import Form from 'react-bootstrap/Form'
import { Card, CardBody, CardFooter, FormGroup, Input, Label,CardTitle, CardHeader } from 'reactstrap';
import { Btn, H4,H5, P,Image } from '../../../AbstractElements';
import RequiredField, { EmailAddress, ForgotPassword, Icons, LoginWithJWT, Password, RememberPassword, SignIn } from '../../../Constant';
import Logo from '../../../assets/images/logo/logo.png'
import { Link, useNavigate } from 'react-router-dom';
import { Jwt_token } from '../../../Config/Config';
import man from '../../../assets/images/dashboard/profile.png';
import { handleResponse } from '../../../Services/fack.backend';
import { toast } from 'react-toastify';
import SweetAlert from 'sweetalert2';
import { Modal, ModalBody, ModalFooter, ModalHeader,Button } from 'reactstrap';
import FadeLoader from 'react-spinners/FadeLoader'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; 
import { faCheck } from '@fortawesome/free-solid-svg-icons';

import CustomizerContext from '../../../_helper/Customizer';
import { LoginCall, ReadRolePermission } from '../../../apiController';
import { IconBase } from 'react-icons';
import { ContactApi } from '../../../api';
import Loader from '../../../Layout/Loader';
// import OtherWay from './OtherWay';

export const override = {
  display: "block",
  margin: "0 auto",
};

const LoginTab = ({ selected }) => {
  const [email, setEmail] = useState('test@gmail.com');
  const [phone, setPhone] = useState('9988776655');
  const [password, setPassword] = useState('123456');
  const [togglePassword, setTogglePassword] = useState(false);
  const history = useNavigate();
  const { layoutURL } = useContext(CustomizerContext);

  const [value, setValue] = useState(localStorage.getItem('profileURL' || man));
  const [name, setName] = useState(localStorage.getItem('Name'));

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [large, setLarge] = useState(false);

  const toggleModal = (type) => {
    if(type === 'log'){
      setLarge(!large)
    } else if (type === 'new'){
      setIsModalOpen(!isModalOpen);
    }
  };

  useEffect(() => {
    localStorage.setItem('profileURL', man);
    localStorage.setItem('Name', 'Emay Walter');
  }, [value, name]);

  const [formdata, setFormdata] = useState({role: null, location: null,});
  const [isLoading, setIsLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    
  } = useForm();

  const loginAuth = async (e) => {
    e.preventDefault();
    setValue(man);
    setName('Emay Walter');
    if (email !== '' && password !== '') {
      localStorage.setItem('login', JSON.stringify(true));
      history(`${process.env.PUBLIC_URL}/pages/sample-page/${layoutURL}`);
    }
  };
  const toRegistration = () => {
    
    history(`${process.env.PUBLIC_URL}/authentication/register/${layoutURL}`);
  };

  const loginWithJwt = (e) => {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: { email, password },
    };

    return fetch('/users/authenticate', requestOptions)
      .then(handleResponse)
      .then((user) => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        setValue(man);
        setName('Emay Walter');
        localStorage.setItem('token', Jwt_token);
        window.location.href = `${process.env.PUBLIC_URL}/pages/sample-page/${layoutURL}`;
        return user;
      });
  };

  const [position, setPosition] = useState({ latitude: null, longitude: null , location: null});

 
  const onSubmit = () => {
    function redirectToDefaultPage() {
        window.location.href = `${process.env.PUBLIC_URL}/pages/sample-page/${layoutURL}`;
        toast.success('Login Successfull', {
          position: toast.POSITION.TOP_CENTER
        })
      }

      setTimeout(redirectToDefaultPage, 50);
  }

   const loginFunction= async(e)  =>{
    e.preventDefault();
    // if ("geolocation" in navigator) {
    //   navigator.geolocation.getCurrentPosition(function (position) {
    //     console.log(navigator.geolocation)
    //     setPosition({
    //       latitude: position.coords.latitude,
    //       longitude: position.coords.longitude,
    //       location: position,
    //     });
    //   });
    // } else {
    //   console.log("Geolocation is not available in your browser.");
    // }
  
    // toggleModal()
    // window.location.href = `${process.env.PUBLIC_URL}/pages/sample-page/${layoutURL}`;
    
    try {
      
      const response = await LoginCall(phone, password);
    const { status, data, message, members_list, token } = response;
      if (status === true) {
        
        setIsLoading(true);
        console.log(data)
        localStorage.setItem('role_id', data.role_id);
        localStorage.setItem('tokenTimestamp', Date.now());
        localStorage.setItem('tokenm', token);

        if (data.role_id === 4 || data.role_id === '4') {
          localStorage.setItem('userdata', JSON.stringify({ "user": members_list[0] }));
          localStorage.setItem('members', JSON.stringify(members_list));
        } else {
          localStorage.setItem('userdata', JSON.stringify({ "user": data }));
          members_list.push(data);
          localStorage.setItem('members', JSON.stringify(members_list));
        }

       
        localStorage.setItem('login', JSON.stringify(true));

        console.log(data)

          if([1,4,5].includes(data.role_id)){
            viewRolePermission({
              role_id: data.role_id
            }, token)
          } else if([2,3].includes(data.role_id)){
            viewRolePermission({
              role_id: data.role_id,
              category_id: data.staff_category_id || data.department_id
            }, token)
          }else{
            console.error('Not found')
          }

      } else if(status === false) {
        console.warn(message)
        toast.error(message, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.error('Login error:', error);
      toast.error('An error occurred during login', {
        position: toast.POSITION.TOP_CENTER
      });
    } finally {

    //   setIsLoading(false);
    //   function redirectToDefaultPage() {
    //     window.location.href = `${process.env.PUBLIC_URL}/pages/sample-page/${layoutURL}`;
    //     toast.success('Login Successfull', {
    //       position: toast.POSITION.TOP_CENTER
    //     })
    //   }

    //   setTimeout(redirectToDefaultPage, 50);
    }

  
  }


  const viewRolePermission = async (formData, token) => {
    try {
      const response = await ReadRolePermission(formData, token);
      if (response.status === true) {
        // const viewData = response.data

        const {data} = await response


        localStorage.setItem('user_permission_data', JSON.stringify(data.permissions))
        // setPermission(viewData.permissions)
        console.log(data.permissions)
        console.log(data)
      }
    } catch (error) {
      toast.error("An error occurred!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally{
      setIsLoading(false);
      function redirectToDefaultPage() {
        window.location.href = `${process.env.PUBLIC_URL}/pages/sample-page/${layoutURL}`;
        toast.success('Login Successfull', {
          position: toast.POSITION.TOP_CENTER
        })
      }

      setTimeout(redirectToDefaultPage, 50);

    }
    
  };

  console.log(position)

  const navTo = (arg) => {
    if(arg === 'ind'){
    window.location.href = `${process.env.PUBLIC_URL}/authentication/register?type=individual`
  } else if (arg === 'org'){
    window.location.href = `${process.env.PUBLIC_URL}/authentication/register?type=organisation`
  }
  }
  const [isSelected, setIsSelected] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  const handleCardClick = (type) => {
    if (type === 'user'){
    setIsSelected(!isSelected);
  } else if(type === 'role'){
    setIsChecked(!isChecked)}
  };
  const navToFrg = () => {
    window.location.href = `${process.env.PUBLIC_URL}/pages/authentication/forget-pwd/${layoutURL}`;
  }

  return (
    <Fragment>
      {/* {isLoading && <Loader/>} */}
      {isLoading && <FadeLoader loading={isLoading} cssOverride={override}
        size={150} />}
      {/* {isLoading && <div className="loader">Loading...</div>} */}
      <Form className='theme-form'>
        <div className='d-flex justify-content-center'>
      <Image attrImage={{ className: ' img-fluid w-50 for-light', src: Logo, alt: 'looginpage' }} />
      </div>
        <H4>Sign In</H4>
        {/* <H4>{selected === 'simpleLogin' ? 'Sign In With Simple Login' : 'Sign In With Jwt'}</H4> */}
        <P>{'Enter your email & password to login'}</P>
        {/* <FormGroup>
          <Label className='col-form-label'>{"User Type"}</Label>
         
          <Input type='select' name="roletype" id="roletype" value='' placeholder='Select your role'>
            <option value="">select your role</option>
            <option value="doctor">Doctor</option>
            <option value="staff">Staff</option>
            <option value="patient">Patient</option>
            <option value="admin">Admin</option>
          </Input>
        </FormGroup> */}
        <FormGroup>
          <Label className='col-form-label'>{"Mobile Number"}</Label>
          <Input className='form-control' type='text' onChange={(e) => setPhone(e.target.value)} value={phone} />
        </FormGroup>
        <FormGroup className='position-relative'>
          <Label className='col-form-label'>{Password}</Label>
          <div className='position-relative'>
            <Input className='form-control' type={togglePassword ? 'text' : 'password'} onChange={(e) => setPassword(e.target.value)} value={password} />
            <div className='show-hide' onClick={() => setTogglePassword(!togglePassword)}>
              <span className={togglePassword ? '' : 'show'}></span>
            </div>
          </div>
        </FormGroup>
        <div className='position-relative form-group mb-0'>
          <div className='checkbox'>
            <Input id='checkbox1' type='checkbox' />
            <Label className='text-muted' for='checkbox1'>
              {RememberPassword}
            </Label>
          </div>
          <a className='link'onClick={()=> navToFrg()}>
            {ForgotPassword}
          </a>
          {selected === 'simpleLogin' ? (
            <Button  color= 'primary' className= 'd-block w-100 mt-2' onClick= {(e) => loginFunction(e)}  disabled = {isLoading}>{isLoading? "Loading...":SignIn}</Button>
            // <Btn attrBtn={{ color: 'primary', className: 'd-block w-100 mt-2', onClick: (e) => loginFunction(e) , disabled: {isLoading}}}>{isLoading? "Loading...":SignIn}</Btn>
          ) : (
            <Btn attrBtn={{ color: 'primary', className: 'd-block w-100 mt-2', onClick: (e) => loginWithJwt(e) }}>{LoginWithJWT}</Btn>
          )}
        </div>

        <P attrPara={{ className: 'text-center mt-5 mb-0 ' }}>
                Don't have account?
                {/* <Link className='ms-2' to={`${process.env.PUBLIC_URL}/authentication/register`}  onClick={toggleModal}>
                  Create Account
                </Link> */}
                <Link className='ms-2'   onClick={()=>navTo("ind")}>
                {/* <Link className='ms-2'   onClick={()=>toggleModal('new')}> */}
                  Create Account
                </Link>
              </P>
        {/* <OtherWay /> */}
      </Form>
      <Modal isOpen={isModalOpen} toggle={toggleModal} centered>
        <ModalHeader className='text-white bg-dark p-2 justify-content-center'>Witte Registration</ModalHeader>
        <ModalBody>
          <Card className="cursor-pointer p-1 m-0" onClick={()=>navTo("org")}>
            <CardBody className='d-flex justify-content-between'>
       <H5>  Register Your Organisation Account  </H5>
       <div className='h4'><i className='fa fa-angle-right'></i></div>
    </CardBody>
          </Card>
          <Card className="cursor-pointer p-1 m-0" onClick={()=>navTo("ind")}>
            <CardBody className='d-flex justify-content-between'>
       <H5>Create Account  </H5>
       <div className='h4'><i className='fa fa-angle-right'></i></div>
    </CardBody>
          </Card>
        </ModalBody>
      </Modal>



      <Modal isOpen={large} toggle={toggleModal} centered onSubmit={handleSubmit(onSubmit)}>
        <ModalHeader className='text-white bg-dark p-2 justify-content-center'>Witte Login</ModalHeader>
        <ModalBody>
          <Form>
          {/* <Card className=" p-1 m-0">
            <CardBody className=''>
       <H5>  Choose Your Role   </H5>
       <FormGroup className="mb-3">
            <Label htmlFor="exampleFormControlSelect9">{"Role Type"} <RequiredField/></Label>
            <select name="role" className="form-control digits" id="role" value={formdata.role} {...register("role", { required: true })} >
            <option  value='Patient'>Select Your Role</option>
            <option  value='Patient'>Patient</option>
            <option  value='Doctor'>Doctor</option>
            </select>
            <span className="text-danger">{errors.role && "Role is required"}</span>
        </FormGroup>
    </CardBody>
          </Card> */}
     <H5>  Choose Your Role   </H5>
          <Card className={isChecked ? 'selected-card' : 'normal-card'} onClick={()=>handleCardClick('role')}>
      <CardBody>
      <div className="card-title-wrapper">
      {isChecked && <FontAwesomeIcon icon={faCheck} className="check-icon" />}
        <CardTitle>User_Role</CardTitle>
        </div>
      </CardBody>
    </Card>
          {/* <Card className='user_name'>
            <CardBody>
          <FormGroup>
            <Label className="d-flex">
                  <Input className={`form-control  checkbox_animated  custom-checkbox ${errors.username && "is-invalid"}`} id='username' type="checkbox" 
                  data-original-title="" title=""  defaultValue={formdata.username || ""} {...register("username", { required: false })}/>
                   {'User_Name'}
              </Label>
          </FormGroup>
          </CardBody>
          </Card> */}
     <H5>  Choose User_Name   </H5>
          <Card className={isSelected ? 'selected-card' : 'normal-card'} onClick={()=>handleCardClick('user')}>
      <CardBody>
      <div className="card-title-wrapper">
      {isSelected && <FontAwesomeIcon icon={faCheck} className="check-icon" />}
        <CardTitle>User_name</CardTitle>
        </div>
      </CardBody>
    </Card>
          <Card className=" p-1 m-0" > 
            <CardBody>
            
            <H5>Choose Your Location</H5>
            <FormGroup className="mb-3">
          <Label htmlFor="exampleFormControlSelect9">{"Location"}</Label>
          <select name="location" className="form-control digits" id="location" value={formdata.location} {...register("location", { required: true })} >
          <option  value='Salem'>Salem</option>
          <option  value='Coimbatore'>Coimbatore</option>
          </select>
          <span className="text-danger">{errors.location && "Location is required"}</span>
          </FormGroup>
          </CardBody>
    <CardFooter>
    <div className="text-end btn-mb mt-5">
            <Btn className="success" type="submit" disabled={isLoading}>
                {isLoading?"Submitting...":"Submit"}
              </Btn>
            </div>  
    </CardFooter>
          </Card>
          </Form>
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default LoginTab;
